
import Vue from 'vue'

export default Vue.extend({
   name: 'QuantitySpinnerComponent',
   props: {
      productPriceId: { type: String, required: true },
      quantity: { type: Number, required: true },
      allowAdjustment: { type: Boolean, default: true },
   },
   data() {
      return {
         working: false,
      }
   },
   methods: {
      async increment() {
         await this.updateQuantity(this.quantity + 1)
      },
      async decrement() {
         await this.updateQuantity(this.quantity - 1)
      },
      async remove() {
         await this.updateQuantity(0)
      },
      async updateQuantity(quantity: number) {
         if (this.working) {
            return
         }
         this.working = true
         await this.$store.dispatch('updateCartQuantity', {
            productPriceId: this.productPriceId,
            quantity,
         })
         this.working = false
      },
   },
})
